var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMedal = function SvgIconMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0M12 6.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.481a8.5 8.5 0 1 0-11 0V22.5a1 1 0 0 0 1.447.894L12 21.368l4.053 2.026A1 1 0 0 0 17.5 22.5zM12 2.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13m3.5 14.248a8.5 8.5 0 0 1-3.5.752 8.5 8.5 0 0 1-3.5-.752v4.134l3.053-1.526a1 1 0 0 1 .894 0l3.053 1.526z"
  }))));
};
export default SvgIconMedal;